module.exports = __webpack_public_path__ + "img/deco-4.95515261.svg";